/**
 * Person detail component created by karora on 24/06/17.
 */
import { switchMap } from 'rxjs/operators';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';
import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Person } from '../types/person';


@Component({
  selector: 'person-detail',
  templateUrl: './person-detail.component.html',
  styleUrls: ['./person-detail.component.css'],
  providers: [VoxPopService],
  standalone: false
})

export class PersonDetailComponent implements OnInit {
  @ViewChild('editButton') editButton: ElementRef<HTMLButtonElement>;
  @ViewChild('typeSelect') typeSelect: ElementRef<HTMLSelectElement>;
  CanAdminister = ProfileService.CanAdminister;
  person: Person;
  errorMessage: string;
  personTypes = [
    // { "person_type_id": 0, "person_type_description": "Invalid" },
    { "person_type_id": 1, "person_type_description": "Public" },
    { "person_type_id": 2, "person_type_description": "Reporter" }
  ];
  editable = false;
  personDraft: Person;
  saving = false;
  saveMessage = '';

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;

    this.route.params.pipe(switchMap((params: Params) => this.voxPopService.getPerson(+params['personid'])))
      .subscribe(
        person => this.setPerson(person),
        error => this.errorMessage = <any>error,
      );
  }

  setPerson(person: Person) {
    this.person = person;
    AppComponent.SetTitle((person.name || 'Person') + ' (' + person.id + ')');
  }

  setEditing() {
    this.personDraft = Object.assign(new Person(), this.person);
    this.errorMessage = '';
    this.saveMessage = '';
    this.editable = true;
    setTimeout(() => this.typeSelect?.nativeElement.focus());
  }

  cancelChanges() {
    if (this.saving) { return; }
    this.editable = false;
    this.personDraft = null;
    this.errorMessage = '';
    setTimeout(() => this.editButton?.nativeElement.focus());
  }

  saveChanges() {
    if (this.saving || !this.personDraft || !this.CanAdminister()) { return; }
    this.saving = true;
    this.errorMessage = '';
    this.voxPopService.updatePerson(Object.assign(new Person(), this.personDraft)).subscribe(
      () => {
        this.saving = false;
        this.editable = false;
        this.personDraft = null;
        this.saveMessage = 'Person saved.';
        setTimeout(() => this.editButton?.nativeElement.focus());
        // Re-read the authorized view: scoped responses intentionally omit global type/GUID.
        this.voxPopService.getPerson(this.person.id).subscribe(
          person => this.setPerson(person),
          () => this.errorMessage = 'Person saved, but details could not be refreshed. Reload to see the current details.',
        );
      },
      () => {
        this.saving = false;
        this.errorMessage = 'Could not save person. Your changes are still here. Please try again.';
      },
    );
  }

  personTypeDescription(p: Person): string {
    switch (p.person_type_id) {
      case 1: return 'Public';
      case 2: return 'Reporter';
      case 0: return 'Not available in this view';
      default: return p.person_type_id == null ? 'Not specified' : `Unknown type (${p.person_type_id})`;
    }
  }
}
